import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VolumeDiscountProfile} from '../../interface/volume-discount-profile';
import {PriceCalculationService} from '../../service/price-calculation.service';
import {VolumeDiscountProfileItem} from '../../interface/volume-discount-profile-item';
import {GetAndSetCartDataInLocalstorageService} from 'src/app/cart/service/set-cart-data-in-localstorage.service';
import {ApCurrency} from "../../../pipe/enum/ap-currency";
import {CurrencyResolverService} from "../../../currency-resolver.service";

@Component({
	selector: 'fb-volume-discount',
	templateUrl: './volume-discount.component.html',
	styleUrls: ['./volume-discount.component.scss']
})
export class VolumeDiscountComponent implements OnInit {
	@Input() dataVolumeDiscount: VolumeDiscountProfile = {} as VolumeDiscountProfile;
	@Output() closeVolumeDiscountOption = new EventEmitter();
	@Input() unit: string = '';
	public selectedCurrency: ApCurrency = ApCurrency.INR;

	public price: number = 0;
	public isFinishSelected: boolean = false;

	public customVolumeDiscountList:any = [];

	constructor(
		private _priceCalculation: PriceCalculationService,
		private _currencyResolver: CurrencyResolverService,
		private _getCartDataInLocal: GetAndSetCartDataInLocalstorageService,
	){

	}
	public closeVolumeDiscount(): void {
		// this._priceCalculation.productQuantity = 1;
		this._priceCalculation.calculatePrice(false,false, 'volume-discount');
		this.closeVolumeDiscountOption.emit();

		// this._priceCalculation.calculatePrice(this.isFinishSelected,false);
		this._getCartDataInLocal.openCartModal.next(false);
	}

	public ngOnInit(): void {

		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});

		let previousQTYInPriceCalculation = this._priceCalculation.productQuantity;
		let volumeDiscount = this.dataVolumeDiscount.volumeDiscountProfileItemList;

		this.dataVolumeDiscount.volumeDiscountProfileItemList = volumeDiscount;

		this.isFinishSelected = !!this._priceCalculation.finishPrice;

		volumeDiscount.forEach((vDiscount: VolumeDiscountProfileItem)=>{

			this._priceCalculation.productQuantity = vDiscount.minimumOrderQuantity;
			this._priceCalculation.calculatePrice(false,false, 'volume-discount');
			this.customVolumeDiscountList.push({

				moq: vDiscount.minimumOrderQuantity,
				discountedPrice: this._priceCalculation.storePrice,
				unit: this.unit
			});
		})

		this.price = this._priceCalculation.storePrice;
		this._priceCalculation.productQuantity = previousQTYInPriceCalculation;
	}

	public discountCalculation(amount: number, discountPercentage: number): number {

		const discount = (discountPercentage / 100) * amount;
		const discountedAmount = amount - discount;
		return discountedAmount;

	}



}
